import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Package } from "lucide-react";
import { ICONS } from "@/components/marketplace/marketplaceIcons";

export function ComingSoonServices({ services, onInterest }) {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-gray-700">Em Breve</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {services.map(svc => {
          const Icon = ICONS[svc.icon] || Package;
          return (
            <Card
              key={svc.id}
              className="bg-card border-border/50 hover:border-primary/20 transition-all group"
              data-testid={`service-card-${svc.id}`}
            >
              <CardContent className="p-5 space-y-4">
                <div className="flex items-start justify-between">
                  <div className={`p-2.5 rounded-lg ${svc.color}`}>
                    <Icon className={`w-5 h-5 ${svc.iconColor}`} />
                  </div>
                  <Badge variant="outline" className="text-[10px] border-amber-500/40 text-amber-600 bg-amber-500/5">
                    Em breve
                  </Badge>
                </div>

                <div>
                  <h3 className="font-bold text-base">{svc.name}</h3>
                  <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{svc.description}</p>
                </div>

                <div className="flex items-center justify-between pt-2 border-t border-border/30">
                  <span className="text-sm font-semibold text-emerald-600">{svc.price}</span>
                  <Button
                    size="sm"
                    variant="outline"
                    className="text-xs"
                    onClick={() => onInterest(svc.name)}
                    data-testid={`service-interest-${svc.id}`}
                  >
                    Tenho interesse
                  </Button>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
